import { BehaviorSubject } from "rxjs";
import { ISelectFormControlOptions } from "../select-form-control";
import { SubjectMapped } from "../types";
import { FormControlOptionsUtils } from "./utils/form-control-options-utils";
import { _SSDataSourceBase } from "./utils/ss-data-source-base";

export class SSSelectOptions extends _SSDataSourceBase implements Required<SubjectMapped<ISelectFormControlOptions>> {

  listItemsSubject = new BehaviorSubject<ISelectFormControlOptions['listItems']>([]);

  constructor(
    private _initialOptions?: ISelectFormControlOptions
  ) {

    super();
    this._initOptions();

  }

  private _initOptions() {

    FormControlOptionsUtils.initMappedObject<'select'>(this, this._initialOptions);

  }

  dispose() {
    this.listItemsSubject.complete();

  }
}
